import {
  CheckboxCustomEvent,
  IonAlert,
  IonAvatar,
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { useSendbirdStateContext } from "@wearesweet/sendbird-uikit-react";
import { useChannelSettingsContext } from "@wearesweet/sendbird-uikit-react/ChannelSettings/context";
import Label, { LabelColors, LabelTypography } from "@wearesweet/sendbird-uikit-react/ui/Label";
import { t } from "i18next";
import { banOutline, personCircleOutline } from "ionicons/icons";
import React, { useContext, useRef } from "react";
import { debug } from "../../../App";
import { AuthenticatedUserContext } from "../../../contexts/AuthenticatedUserContext";

export const BlockMember = (props: any) => {
  const context = useChannelSettingsContext();
  const modal = useRef<HTMLIonModalElement>(null);
  const [checkedState, setCheckedState] = React.useState<{ [key: string]: boolean }>({});
  const [alertIsOpen, setAlertIsOpen] = React.useState(false);
  const authenticatedUser = useContext(AuthenticatedUserContext);
  const authenticatedMember = authenticatedUser?.member;
  const sdk = useSendbirdStateContext();
  const [present] = useIonToast();

  const initiate = () => {
    if (context.channel?.members.length === 2) {
      // they're in a channel with just one other person, so assume it's the person not them that they want to block
      // get the ID of the user that isn't them
      const otherMember = context.channel.members.find((member) => member.userId !== authenticatedMember!.id.toString());
      if (otherMember) {
        setCheckedState({ [otherMember.userId]: true });
        setAlertIsOpen(true);
      }
    } else {
      setCheckedState({});
      modal.current?.present();
    }
  };
  const doBlock = async () => {
    const membersToBlock = context.channel?.members.filter((member) => checkedState[member.userId]);
    if (membersToBlock?.length) {
      // for each of the members to block, block them
      for (let i = 0; i < membersToBlock.length; i++) {
        debug("Blocking user", membersToBlock[i].userId);
        await sdk.stores.sdkStore.sdk.blockUserWithUserId(membersToBlock[i].userId);
      }
    }

    setAlertIsOpen(false);
    modal.current?.dismiss();
    await present("The " + (membersToBlock?.length === 1 ? "person has" : "selected people have") + " been blocked", 3000);
  };

  return (
    <>
      <IonAlert
        isOpen={alertIsOpen}
        header={t("areYouSure") || ""}
        message={t("areYouSureYouWantToBlock") || ""}
        buttons={[
          {
            text: t("cancel"),
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              setAlertIsOpen(false);
            },
          },
          {
            text: t("block"),
            handler: () => {
              doBlock();
            },
          },
        ]}
      />
      <IonModal trigger={"block-member"} ref={modal}>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => modal.current?.dismiss()}>{t("cancel")}</IonButton>
            </IonButtons>
            <IonTitle>{t("blockMembers")}</IonTitle>
            <IonButtons slot="end">
              <IonButton strong={true} onClick={() => setAlertIsOpen(true)}>
                {t("block")}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonList inset={true}>
            {context.channel?.members
              ?.filter((member) => {
                return member.userId !== authenticatedMember!.id.toString();
              })
              .map((member) => (
                <IonItem key={`blockMemberList-${member.userId}-${checkedState[member.userId]}`}>
                  <IonAvatar slot={"start"}>{member.plainProfileUrl ? <img src={member.plainProfileUrl} alt={member.nickname} /> : <IonIcon icon={personCircleOutline} size={"large"} />}</IonAvatar>
                  <IonCheckbox
                    slot="end"
                    checked={checkedState[member.userId]}
                    onIonChange={(e: CheckboxCustomEvent) => {
                      const newCheckedState = { ...checkedState };
                      newCheckedState[member.userId] = e.detail.checked;
                      debug("Setting checkedState to", JSON.stringify(newCheckedState));
                      setCheckedState(newCheckedState);
                    }}
                  ></IonCheckbox>
                  <IonLabel>{member.nickname}</IonLabel>
                </IonItem>
              ))}
          </IonList>
        </IonContent>
      </IonModal>
      <div className="sendbird-channel-settings__block sendbird-channel-settings__panel-item" role="button" onClick={initiate}>
        <IonIcon icon={banOutline} className={"sendbird-channel-settings__accordion-icon sendbird-icon sendbird-icon-block sendbird-icon-color--primary"} />
        <Label type={LabelTypography.SUBTITLE_1} color={LabelColors.ONBACKGROUND_1}>
          {t("block")}
        </Label>
      </div>
    </>
  );
};
